import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { TimeScale } from 'chart.js';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-student-change-password',
  templateUrl: './student-change-password.component.html',
  styleUrls: ['./student-change-password.component.scss']
})
export class StudentChangePasswordComponent implements OnInit {

district_list: any[] = this.ApiService.all_districts;
  users: any = JSON.parse(localStorage.getItem('login_user_details'));
  permanent_token:any=JSON.parse(localStorage.getItem('permanent_token'));

  district: any;
  constituency: string = '';
  OBConstituency: string;
  user_constituency: any = this.ApiService.all_constituency['Chennai North'];
  assigned_to: any;
  zones: any = this.ApiService.zones;
  user_name: any = this.ApiService.user_details.firstname;
  user_id: any = this.ApiService.user_details.id;
  activity_type: any;
  activity_date: any;
  activity_time: any;
  activity: any;
  description: any;
  status: any;
  others: any;
  customers: any = [];
  summary_activity: any = [];
    MeetingOptions:any;
  participantsptions:any;
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform !:FormGroup;
  constituencies!:any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden:boolean=true;
  dropdownList : string[]= [];
  dropdownSettings: IDropdownSettings = {};
  add = [];
  name: any;
  last_name: any;
  DOB: any;
  education: any;
  email: any;
  number: any;
  parent_number: any;
  branch: any;
  area: any;
  courses: any;
  grade: any;
  college_name: any;
  subject: any;
  uploadFiles: any = '';
  list_courses: any = [];
  password: any = '';
  confirm_password: any = '';
  userForm: any = JSON.parse(localStorage.getItem('login_user_details'));
  password_wrong: any = false;
  

  
  
 
  selectedItems = [];
  
  dropDownForm: FormGroup;
  tableshow: boolean=false;
  editmeetingform !:FormGroup;
  CM_id: any;
  CM_zone: any;


  getChangeAssignedTo(assigned_to: any) {
    console.log(assigned_to)
    if (assigned_to === 'District') {
      $('#Check1').css('display','flex')
    } else {
       $('#Check1').css('display','none')
    }
      if (assigned_to === 'Zone') {
      $('#zones').css('display','block')
    } else {
       $('#zones').css('display','none')
    }
  }


  getChangeToConstituey(value: any) {
    console.log(value);
    this.user_constituency = this.ApiService.all_constituency[value];
      this.ApiService.datablelogin(value).subscribe((data: any) => {
      let obj = data;
        this.customers = obj.data;
  
      //console.log(obj.data.length);
    });
  }

  handleActivityTypeChange(value: any) {
    console.log(value);
    if (value === 'Others') {
      $('#others').css('display', 'block');
    } else {
        $('#others').css('display', 'none');
    }
  }



  handleDeleteClick(id: any) {
    
    $(`#adding_${id}`).remove();
  }

   onItemSelect(item: any) {
    console.log('onItemSelect', item);
  }
  onItemDeSelect(item: any) {
      console.log('onItemDeSelect', item);
  }
  onSelectAll(items: any) {
      console.log('onSelectAll', items);
  }
  onUnSelectAll() {
      console.log('onUnSelectAll fires');
  }

  

  constructor(private fb: FormBuilder,private ApiService: ApiServiceService,private router:Router,private spinnerService: NgxSpinnerService,
    public datepipe:DatePipe, private elementRef: ElementRef, private renderer: Renderer2) {
    this.createmeetingform= this.fb.group({
        password: ['', Validators.required],
      confirm_password: ['', Validators.required],
    });
    this.editformInitialize('false');

  }


  dtOptions: DataTables.Settings = {};
  date:any;
  ngOnInit(): void{
    console.log(this.users,this.users.firstname, "sndknsdkjn");
  this.date=new Date();
// document.write(today);
    this.customers=[];
    this.showSpinner();
    this.ApiService.getMentorsList().subscribe((data: any) => {
      console.log(data,"s,mfdnsd");
     
      this.customers=data;
      this.tableshow=true;
      //console.log(this.customers.length);
      //console.log(obj.data.length);
      console.log(this.customers,"dsdksbk");
      ;
    })
    
    this.ApiService.getCourses().subscribe((data: any) => {
      console.log('data', data);
      this.dropdownList = data.map(res => res.course_name);
    })

    // this.getdata();
    // this.ApiService.viewtableOB();
    // this.ApiService.viewtableDA();
    // this.ApiService.viewtableSA();
    // this.ApiService.viewtableOBapprove();
    // this.ApiService.viewtablemeeting();
    this.dtOptions = {
      pagingType: 'full_numbers'
    };

    
  
   
    this.selectedItems = [
      { }
    ];
    this.dropDownForm = this.fb.group({
      courses: [this.selectedItems]
  });
  
 

  }
  //Default date time in form
  current_date:any;
  current_time;any;
  setCurrentdate(){
    this.current_date=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.current_time=this.datepipe.transform(new Date(), 'HH:mm');
    this.createmeetingform.get('activity_date').setValue(this.current_date);
    this.createmeetingform.get('activity_time').setValue(this.current_time);
  }
  public showSpinner(): void {
    this.spinnerService.show();
    }

  
  getdata(){
    this.customers=[];
        for(const prop in this.ApiService.tabledatameeting) {
            this.customers.push(this.ApiService.tabledatameeting[prop])
          }
          this.customers.pop();
    //console.log(this.ApiService.tabledataDA)
    //this.ApiService.viewtableOB();
    

  }

    selectFiles(event:any) {
    console.log(event.target.files[0].name, "dnjsndk");
    if (event.target.files[0].size < 60000) {  
      const formData: FormData = new FormData();
      formData.append('file', event.target.files[0]);
      this.ApiService.uploadActivityFile(formData).subscribe((da: any) => {
        this.uploadFiles = da;
      })
  
    } else {
      alert('The size should be less than 60kb');
      $('#file').val('');
    }
    
  }


  handleClickNavigate(id: any) {
    this.router.navigate(['activity-summary', id]);
  }

   handleBlurChange() {
    let password = $('#password').val();
    let confirm_password = $('#confirm_password').val();
    if (password !== confirm_password) {
      this.password_wrong = true;
    } else {
      this.password_wrong = false;
    }
  }
  isFormEmpty(): boolean {
    const password = this.createmeetingform.get('password').value;
    const confirm_password = this.createmeetingform.get('confirm_password').value;
    return !password.trim() || !confirm_password.trim();
  }
  

  postdata(angForm1: any) {
    console.log(angForm1, "dsnkjkdsjnd");
    console.log(this.createmeetingform.status,
        angForm1,
        angForm1.value.meeting_name,
        angForm1.value.meeting_date,
    );

    // this.spinner = true;

    setTimeout(() => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'Want to change password',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            confirmButtonColor: '#015792',
            cancelButtonText: 'No',
            cancelButtonColor: '#e5183b'
        }).then((result) => {
            if (result.isConfirmed) {
                // Change the password only after confirmation
                // this.spinner = true;
                this.ApiService.updatePassword(angForm1.value, this.userForm.id).subscribe((d: any) => {
                        this.spinner = false;
                       
                        Swal.fire({
                            title: 'Success!',
                            text: 'Password changed successfully',
                            icon: 'success',
                            confirmButtonColor: '#015792',
                            iconColor: "#015792"
                        }).then(() => {
                            this.router.navigate(['']);
                        });
                    },
                    error => {
                        this.spinner = false;
                        console.error(error);
                        // Show error message
                        Swal.fire({
                            title: 'Error',
                            text: 'Failed to change password. Please try again later.',
                            icon: 'error',
                            confirmButtonColor: '#015792',
                        });
                    }
                );
            }
        });
    }, 100);
}


    delete_CM(id : any){
      console.log(id)
      if(confirm("Are you sure want to cancel this Mentor ?")) {
        console.log("Implement delete functionality here");
          this.ApiService.deleteMentor(id)
          .pipe()
          .subscribe(
            data => {
              Swal.fire({
                title: "Mentor has been Deleted!",
                icon: "success",
                confirmButtonText: "Okay",
                iconColor: "#015792" 
              }).then(() => {
                window.location.reload();
              });
            },
            

          error => {
              console.log(error);
          });

  }
}

    

  radiobutton(option:any){
    this.MeetingOptions=option;
    // console.log(this.MeetingOptions);
  }
 
  CM_name: any;
  CM_last_name: any;
  CM_education: any;
  CM_branch: any;
  CM_area: any;
  CM_courses: any;
  CM_meeting_location:any;
  CM_date:any;
  CM_time: any;
  CM_description: any;
  CM_activity_type:any;
  CM_comments:any;
  CM_participants:any;
  CM_constituency: any;
  CM_assigned_to: any;
  CM_status: any;
  CM_activity: any;
  CM_others: any;
  CM_district: any;
  CM_father_name: any;
  CM_DOB: any;
  CM_email: any;
  CM_number: any;
  CM_parent_number: any;
  CM_grade: any;
  CM_college_name: any;
  CM_subject: any;
  CM_image: any;
  

editfield:boolean=false;
  buttonviewmeeting(a:any,editbutton:any ){
    console.log(a,editbutton,"dsbskdb");
    //console.log(a.date)
    if (editbutton == 'edit') {
      $('#card_title').html('MENTOR EDIT');
      this.editfield = true;
    } else {
      $('#card_title').html('MENTOR DETAILS');
      this.editfield = false;

    }
    this.CM_name = a.first_name;
    this.CM_last_name = a.last_name;
    this.CM_education = a.education;
    this.CM_email = a.email;
    this.CM_number = a.number;
    this.CM_area = a.area;
    this.CM_courses = a.courses;
    this.CM_district = a.district;
    this.CM_constituency = a.constituency;
    this.CM_status = a.status;
    this.CM_branch = a.branch;
    this.CM_image = a.image; 
    this.uploadFiles = a.image;
    this.CM_id = a.id;
          
          this.editformInitialize(false);
    
    this.editmeetingform.get('name').setValue(a.first_name);
    this.editmeetingform.get('last_name').setValue(a.last_name);
    this.editmeetingform.get('education').setValue(a.education);
    this.editmeetingform.get('email').setValue(a.email);
    this.editmeetingform.get('number').setValue(a.number);
    this.editmeetingform.get('branch').setValue(a.branch);
    this.editmeetingform.get('district').setValue(a.district);
    this.editmeetingform.get('constituency').setValue(a.constituency);
    this.editmeetingform.get('area').setValue(a.area);
    this.editmeetingform.get('courses').setValue(a.courses);
    this.editmeetingform.get('status').setValue(a.status);


     if (a.district !== null) {
      this.CM_constituency = a.constituency;
      this.CM_district = a.district;
      console.log(a.district, "dnsdknd");
      this.district = a.district;
      this.editmeetingform.get('district').setValue(a.district);
      this.user_constituency = this.ApiService.all_constituency[a.district];
      this.editmeetingform.get('constituency').setValue(a.constituency)

    }

    }
                 
          
  editformInitialize(a){
    this.editmeetingform= this.fb.group({
      name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      last_name:['',Validators.required,],
      education:['',Validators.required],
      branch:['',Validators.required],
      constituency:['',Validators.required],
      email:['',Validators.required],
      number:['',Validators.required],
      area:['',Validators.required],
      courses:['',Validators.required],
      district:['',Validators.required],
      status: ['', Validators.required],
      image: ['', Validators.required],
      
  });
  }

  updatedata(updateform,id){
    console.log(updateform.value, this.CM_id, "lmdldk");  
    let values = updateform.value;
    values['image'] = this.uploadFiles;
    // this.spinner = true;
    this.ApiService.updateMentor(this.CM_id,values).pipe().subscribe(
      data => {
        console.log(data);
        this.spinnerService.hide();
        setTimeout(function () {
          Swal.fire({
            title: "Mentor has been updated!",
            icon: "success",
            confirmButtonText: "Okay",
            iconColor: "#015792" // Set the icon color here
          }).then(() => {
            window.location.reload();
          });
        }, 100);
        
        },
      
      error => {
        console.log(error);
      });
  }
//reset form values in createform
  Formreset(){
      this.createmeetingform.reset();
      this.hidden=true;
      this.MeetingOptions='';
      this.participantsptions='';
  }

  hidePassword = true;
  hidePassword1 = true;

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }
  togglePasswordVisibility1(): void {
    this.hidePassword1 = !this.hidePassword1;
  }
}
